import React from 'react';

// DEPENDENCIES
import snakeCase from 'lodash/snakeCase';

// GLOBAL FUNCTIONS
import { fileDownload } from 'functions.js';

// HELPERS
import { useReport } from '../helpers/getReportData';

// GLOBAL TOOLS
import { ExcelButton } from 'routers/interface/tools/ExcelButtons';

// MAIN COMPONENT
const ReportExcelButton = ({
  endpoint,
  params = {}
}) => {

  // HOOKS
  const {filters = {}, report_title } = useReport();

  // RENDER
  return (
    <ExcelButton
      variant="success"
      label="Export to Excel"
      icon="download-excel"
      args={{
        endpoint,
        loadingMessage: 'Downloading report',
        errorMessage: 'Unable to download report.',
        onSuccess: ({ url }) => fileDownload(url, snakeCase(report_title), 'xls', true)
      }}
      params={{...filters, ...params}}
    />
  );
};

// EXPORT
export default ReportExcelButton;
